import React from "react";
import Loadable from "react-loadable";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";

import { AsynLoader } from "../Loader/AsynLoader";
import Modal from "../Modals";
import { queryStringTourType } from "../../actions";
import { generateQueryStringFromReduxState, queryString } from "../../utils";

class TourType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tourType: "",
      str: "",
      showModal: false,
      redirect: ""
    };
  }
  componentWillUnmount() {
    window.removeEventListener("mousedown", this.detectClickOutSide);
  }
  componentDidMount() {
    window.addEventListener("mousedown", this.detectClickOutSide);
  }

  componentDidUpdate(prevProps) {
    if (this.props.query.tourType !== prevProps.query.tourType) {
      const tourType = this.props.query.tourType;
      this.setState({ tourType });
      this.createString(tourType);
    }
  }

  handleSelect = tourType => {
    let q = generateQueryStringFromReduxState(this.props.query);
    q.tourType = tourType;
    this.setState({
      tourType,
      showModal: false,
      redirect: "/activity?" + queryString.stringify(q)
    });
    this.createString(tourType);
    this.props.queryStringTourType(tourType);
  };

  handleReset = () => {
    let q = generateQueryStringFromReduxState(this.props.query);
    delete q.tourType;
    this.setState({
      tourType: "",
      showModal: false,
      redirect: "/activity?" + queryString.stringify(q)
    });
    this.props.queryStringTourType("");
  };

  detectClickOutSide = e => {
    if (window.innerWidth > 700)
      if (!this.tourTypeRef.contains(e.target)) {
        this.setState({ showModal: false });
      }
  };

  handleResetCross = e => {
    e.stopPropagation();
    this.handleReset();
  };

  createString = tourType => {
    console.log("Tour Type ", tourType);

    switch (tourType) {
      case "small":
        this.setState({ str: "Up to 4 hours" });
        break;
      case "single-day":
        this.setState({ str: "4 hours to 1 day" });
        break;
      case "multi-day":
        this.setState({ str: "Multi-day Tours" });
        break;
      case "private":
        this.setState({ str: "Private Tours" });
        break;
      case "group":
        this.setState({ str: "Group Tours" });
        break;
      default:
        this.setState({ str: "Tour Type" });
        break;
    }
  };
  render() {
    console.log(this.state);
    const { active } = this.props;
    return (
      <div className="t-container-fluid" ref={node => (this.tourTypeRef = node)}>
        {this.state.redirect !== "" && <Redirect to={this.state.redirect} />}
        <div
          className={`filter__buttons__tertiary ${active ? "active" : ""}`}
          onClick={() => this.setState(prev => ({ showModal: !prev.showModal }))}>
          <div
            style={{
              maxWidth: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}>
            {this.state.str !== "" ? this.state.str : "Tour Type"}
            {active && <div className="clear" onClick={this.handleResetCross} />}
          </div>
        </div>

        {this.state.showModal && (
          <MediaQuery maxWidth={700}>
            {matches => {
              if (matches) {
                return (
                  <Modal close={() => this.setState({ showModal: false })} reset={this.handleReset}>
                    <AsynTourTypeModal handleSelect={this.handleSelect} selected={this.state.tourType} />
                  </Modal>
                );
              } else {
                return (
                  <ul className="dropdown__list">
                    <li className="item" onClick={() => this.handleSelect("small")}>
                      Up to 4 hours
                    </li>
                    <li className="item" onClick={() => this.handleSelect("single-day")}>
                      4 hours to 1 day
                    </li>
                    <li className="item" onClick={() => this.handleSelect("multi-day")}>
                      Multi-day Tours
                    </li>
                    <li className="item" onClick={() => this.handleSelect("private")}>
                      Private Tours
                    </li>
                    <li className="item" onClick={() => this.handleSelect("group")}>
                      Group Tours
                    </li>
                  </ul>
                );
              }
            }}
          </MediaQuery>
        )}
      </div>
    );
  }
}

const AsynTourTypeModal = Loadable({
  loader: () => import("../Modals/TourType"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader,
  delay: 0
});

const mapStateToProps = state => {
  return {
    query: state.queryString
  };
};
const mapDispatchToProps = dispatch => {
  return { queryStringTourType: tourType => dispatch(queryStringTourType(tourType)) };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TourType);
